<template>
  <div class="chart-card h-full flex flex-col print:border-green-500/80">
    <div class="chart-header">
      <div>
        <h3 class="chart-title print:text-black">{{ title }}</h3>
        <p v-if="subtitle" class="chart-subtitle print:text-black">
          {{ subtitle }}
        </p>
      </div>

      <slot name="actions"></slot>
    </div>

    <div class="chart-body flex-1">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    default: "",
  },
});
</script>

<style scoped>
.chart-card {
  border: 1px solid rgba(239, 68, 68, 0.1);
  background: #111111;
  border-radius: 20px;
  padding: 24px;
  transition: all 0.3s ease;
  box-shadow: 0 0 30px rgba(239, 68, 68, 0.08);
}

.chart-card:hover {
  border: 1px solid rgba(239, 68, 68, 0.2);
  box-shadow: 0 0 40px rgba(239, 68, 68, 0.15);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.chart-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.chart-subtitle {
  font-size: 13px;
  color: #9ca3af;
  margin-top: 4px;
}

.chart-body {
  height: 260px;
  width: 100%;
}

@media print {
  .chart-card {
    border: 1px solid rgb(34 197 94 / 0.8);
  }

  .chart-title {
    color: black;
  }

  .chart-subtitle {
    color: black;
  }
}

</style>
